import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface FileStorageServiceInterface {
    storeCompressedData<T>(storageId: string, data: T, timestamp?: number): Observable<T>;
    loadCompressedData<T>(storageId: string): Observable<T>;
    loadCompressedDataWithTimestamp<T>(storageId: string): Observable<{ data: T; timestamp: number }>;
    loadCompressedDataWithTimestampFromLiveQuery<T>(
        storageId: string,
    ): Observable<{ data: T; timestamp: number } | undefined>;
    checkCompressedData(storageId: string): Observable<boolean>;
    removeCompressedData(storageId: string): Observable<void>;
    /**
     * Upgrades all entries from legacy encryption to the current encryption format.
     *
     * This method performs a read-write transaction on the collection of stored entries.
     * It finds all entries whose content starts with the legacy prefix,
     * re-encrypts their content using the `encryptionMigrator`, and updates the entries
     * in the database.
     *
     * This method is only relevant for the transition period from GW encryption
     * keys to Azure encryption keys. Once, all users that have on encryption
     * key on GW also have an encryption key on Azure, it can safely be removed.
     * ~ summer 2026 should be safe
     *
     * @returns {Observable<boolean>} An observable that emits `true` once all legacy
     * encrypted entries have been successfully migrated.
     */
    upgradeEncryption(): Observable<boolean>;
    /**
     *
     * Checks if there are any entries using legacy encryption format.
     *
     * This method queries the collection of stored entries and determines whether
     * any entry's content starts with the legacy encryption prefix.
     *
     * This method is only relevant for the transition period from GW encryption
     * keys to Azure encryption keys. Once, all users that have on encryption
     * key on GW also have an encryption key on Azure, it can safely be removed.
     * ~ summer 2026 should be safe
     *
     * @returns {Observable<boolean>} An observable that emits `true` if at least one
     * entry uses legacy encryption, otherwise `false`.
     */
    hasLegacyEncryption(): Observable<boolean>;
}

export const FileStorageInjectionToken = new InjectionToken<FileStorageServiceInterface>('FileStorageServiceInterface');
